module.exports = function() {
  return new Worker(__webpack_public_path__ + "b9ff62c6433fd2810971.worker.js");
};